import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import InformapClientDetails from './components/InformapClientDetails';
import PndApi from '../../../../utils/pnd/PndRestApi';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import UpdateClientInformationModal from '../AddOrUpdate/components/UpdateClientInformationModal';
import EditIcon from '@mui/icons-material/Edit';
import { Tooltip } from '@mui/material';
import { showNotification } from 'src/shared/components/Notification';
import { getSubscriptionStatus } from 'src/utils/validationUtils/';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import Badge from "react-bootstrap/Badge";
const InformapClientDetailsView = () => {
  useEffect(() => {
    getAllInformapClientDetails();

  }, [])
  const [reactTableData, setReactTableData] = useState([]);
  // const [reactTableSubScriptionData, setReactTablSubScriptioneData] = useState([]);
  const [temp, setTempData] = useState("");
  // const [tempSubScription, setSubScriptionData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  // const [viewSubSettingPopup, setSubSettingPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);

  const getAllInformapClientDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllInformapClientDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
        //setReactTablSubScriptioneData({ tableHeaderData: columnsSubScription, tableRowsData: response.data.data });
      } else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);
      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response?.data?.message ? response?.data?.message : ERROR_MESSAGES.tryCatchError}`,

        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };


  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 45,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Client Name',
        accessor: 'clientName',
        disableSortBy: false,
        // disableGlobalFilter: false,
      },
      {
        Header: 'Account No.',
        accessor: 'accountNo',
        disableGlobalFilter: false,
        // width: 30,
      },
      {
        Header: 'Mobile No.',
        accessor: 'mobileNo',
        disableGlobalFilter: true,
        // width: 70,
      },
      // {
      //   Header: 'Email Id',
      //   accessor: 'emailId',
      //   disableGlobalFilter: true,
      // },
      {
        Header: 'Sub. Start',
        accessor: 'subscriptionStartDate',
        disableGlobalFilter: false,

      },
      {
        Header: 'End Date',
        accessor: 'subscriptionEndDate',
        disableGlobalFilter: false,
        // width: 55,
        Cell: ({ value }) => {
          const status = getSubscriptionStatus(value);
          let badgeStyle = {
            padding: '6px 12px',
            borderRadius: '6px',
            fontSize: '0.78rem',
            fontWeight: '600',
            display: 'inline-block',
            textAlign: 'center',
            minWidth: '95px'
          };

          switch (status) {
            case 'expired':
              badgeStyle = {
                ...badgeStyle,
                backgroundColor: '#fef2f2',
                color: '#ef4444',
                border: '1px solid #fee2e2',
              };
              break;
            case 'expiring-this-month':
              badgeStyle = {
                ...badgeStyle,
                backgroundColor: '#fffbeb',
                color: '#d97706',
                border: '1px solid #fef3c7',
              };
              break;
            case 'expiring-next-month':
              badgeStyle = {
                ...badgeStyle,
                backgroundColor: '#fff7ed',
                color: '#ea580c',
                border: '1px solid #ffedd5',
              };
              break;
            default:
              badgeStyle = {
                ...badgeStyle,
                backgroundColor: '#f0fdf4',
                color: '#16a34a',
                border: '1px solid #dcfce7',
              };
          }

          return (
            <div style={badgeStyle}>
              {value || '—'}
            </div>
          );
        },
      },
      // {
      //   Header: 'Plan Name',
      //   accessor: 'customerSubscriptionPlanInfo.planName',
      //   disableGlobalFilter: false,
      //
      // },
      // {
      //   Header: 'Payment Plan',
      //   accessor: 'customerPaymentPlanInfo.planName',
      //   disableGlobalFilter: false,
      //   width: 30,
      // },
      {
        Header: "Opern. Status",
        accessor: "status",
        disableSortBy: false,
        // width: 20,
        Cell: ({ row }) => {
          const isActive = row.original.status === 1;
          return (
            <span style={{
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '0.72rem',
              fontWeight: '700',
              backgroundColor: isActive ? '#e6f4ea' : '#fce8e6',
              color: isActive ? '#137333' : '#c5221f',
              border: isActive ? '1px solid #ceead6' : '1px solid #fad2cf',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              display: 'inline-block',
              textAlign: 'center'
            }}>
              {isActive ? 'ACTIVE' : 'IN-ACTIVE'}
            </span>
          );
        }
      },
      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div style={{ display: 'flex', justifyContent: 'left' }}>
            <Tooltip title="Click here to Edit the details" arrow>
              <button
                onClick={() => edit(row.original)}
                style={{
                  border: 'none',
                  backgroundColor: '#f1f5f9',
                  color: '#475569',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e2e8f0'; e.currentTarget.style.color = '#0f172a'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; e.currentTarget.style.color = '#475569'; }}
              >
                <EditIcon style={{ fontSize: '1.1rem' }} />
              </button>
            </Tooltip>
          </div>
        ),
      },
    ],
    [],
  );
  const edit = async (event) => {
    if (event.customerId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Informap Client Details");
    }
  }

  return (
    <Container>
      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && <InformapClientDetails reactTableData={reactTableData} isNoRecordFound={isNoRecordFound} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {isNoRecordFound && <InformapClientDetails reactTableData={reactTableData} isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}

      {viewDetailPopup && temp &&
        <UpdateClientInformationModal
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          clientInfoData={temp}
          isTitle={isTitle} />
      }
    </Container>
  );
};

export default InformapClientDetailsView;